import { Pagination } from 'antd'
import React from 'react'
import usePagination from '../hooks/usePagination'

type Props = {
    hookPagination?: ReturnType<typeof usePagination<any>>
    align?: 'start' | 'center' | 'end';
    totalItems?: number;
    defaultPageSize?: number;
    page?: number;
    onChange?: (page: number, pageSize: number) => void;
}

const PaginationComp: React.FC<Props> = ({
    align = 'end',
    hookPagination,
    totalItems = 0,
    defaultPageSize = 10,
    page,
    onChange
}: Props) => {
    const current = hookPagination ? hookPagination.page : page;
    const pageSize = hookPagination ? hookPagination.pageSize : defaultPageSize;
    const total = hookPagination ? hookPagination.totalItems : totalItems;
    const handleChange = hookPagination ? hookPagination.changePage : onChange;

    return (
        <Pagination
            align={align}
            defaultCurrent={1}
            pageSizeOptions={['10', '25', '50', '100']}
            showTotal={total => `Total ${total} elementos`}
            current={current}
            pageSize={pageSize}
            total={total}
            onChange={handleChange}
        />
    )
}

export default PaginationComp